/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Source_LicenseInputs */

const fr_legal_source_license = /** @type {(inputs: Legal_Source_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le code source est mis à disposition sous licence GNU General Public License v3.0. Vous êtes libre de le consulter et de le modifier selon les termes de cette licence sur`)
};

const en_legal_source_license = /** @type {(inputs: Legal_Source_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The source code is made available under the GNU General Public License v3.0. You are free to view and modify it under the terms of this license on`)
};

/**
* | output |
* | --- |
* | "The source code is made available under the GNU General Public License v3.0. You are free to view and modify it under the terms of this license on" |
*
* @param {Legal_Source_LicenseInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_source_license = /** @type {((inputs?: Legal_Source_LicenseInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Source_LicenseInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_source_license(inputs)
	return en_legal_source_license(inputs)
});